import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/303'

const AveragePurchasesPerLocationPerMonthTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="capture_rate.tabs.average_purchases_per_location_per_month"
  />
)

export default AveragePurchasesPerLocationPerMonthTab
